import { ConversationsSearchResultMatch } from '@mm/state/actions/LiveChatCRUDActions';
import { ENTER_KEY_NAME } from '@mm/constants/keys-codes';
import { useActor } from '@xstate/react';
import React, { useState } from 'react';
import { useContextSelector } from 'use-context-selector';
import { SearchInput } from '../../../../../../common/components/SearchInput/SearchInput';
import { LiveChatContext } from '../../../LiveChatContext';
import { LcSearchStates } from '../../../liveChatMachine';

export const LcSearch = () => {
  const [searchTimeout, setSearchTimeout] = useState(0);

  const lcService = useContextSelector(
    LiveChatContext,
    v => v.lcServiceRef.current!,
  );

  const [lcMachineState] = useActor(lcService);
  const lcMachineSend = lcService.send;

  const { searchString, remoteUserId: selectedRemoteUserId } =
    lcMachineState.context;

  const setSearchResultMatches = (matches: ConversationsSearchResultMatch[]) =>
    lcMachineSend({
      type: 'LC_CONTEXT_UPDATE',
      payload: {
        searchResultMatches: matches,
      },
    });

  const clearSearchResultsMessages = () =>
    lcMachineSend({
      type: 'LC_CONTEXT_UPDATE',
      payload: {
        searchResultsMessages: [],
      },
    });

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.trimLeft();
    if (newValue === '') {
      lcMachineSend({
        type: 'LC_CONTEXT_UPDATE',
        payload: {
          searchString: newValue,
          foundContacts: [],
          foundConversations: undefined,
        },
      });
      if (selectedRemoteUserId !== undefined) {
        lcMachineSend({
          type: 'LC_REMOTE_USER_ID_CHANGE',
          payload: undefined,
        });
      }
    }
    if (searchTimeout > 0) {
      clearTimeout(searchTimeout);
      setSearchTimeout(0);
    }
    if (newValue !== searchString) {
      setSearchResultMatches([]);
      clearSearchResultsMessages();
      lcMachineSend({
        type: 'LC_CONTEXT_UPDATE',
        payload: {
          searchString: newValue,
        },
      });
      if (newValue.length > 1) {
        const newTimeout = window.setTimeout(() => {
          lcMachineSend({
            type: 'LC_SEARCH',
          });
        }, 600);
        setSearchTimeout(newTimeout);
      }
    }
  };

  const onSearchInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === ENTER_KEY_NAME &&
      !lcMachineState.matches({
        mainLogic: { active: { contactSearch: LcSearchStates.searching } },
      }) &&
      !lcMachineState.matches({
        mainLogic: { active: { conversationSearch: LcSearchStates.searching } },
      })
    ) {
      if (searchString && searchString.length > 1) {
        lcMachineSend({
          type: 'LC_SEARCH',
        });
      }
    }
  };

  return (
    <SearchInput
      className="live-chat--left-pane__search--input"
      iconClassName="live-chat--search-icon"
      inputClassName="live-chat--left-pane__search--input--input"
      placeholder="Search live chat"
      value={searchString}
      autoFocus
      onChange={onSearchInputChange}
      onKeyDown={onSearchInputKeyDown}
      hasBorder={false}
    />
  );
};
